<template>
  <div class="pb-3">
    <va-card :title="$t(`notificacoesLink.cards.send`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(send)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Titulo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacaoLink.title"
                  :label="$t('notificacoesLink.forms.titleLabel')"
                  :placeholder="$t('notificacoesLink.forms.titlePlaceholder')"
                  :success="errors.length == 0 && notificacaoLink.title.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Corpo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacaoLink.subtitle"
                  :label="$t('notificacoesLink.forms.subtitleLabel')"
                  :placeholder="$t('notificacoesLink.forms.subtitlePlaceholder')"
                  :success="errors.length == 0 && notificacaoLink.subtitle.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="URL da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacaoLink.url"
                  :label="$t('notificacoesLink.forms.urlLabel')"
                  :placeholder="$t('notificacoesLink.forms.urlPlaceholder')"
                  :success="errors.length == 0 && notificacaoLink.url.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </div>
            <div class="d-flex mt-1">
              <va-button
                type="submit"
                :disabled="buttonSubmitDisabled"
                color="success"
                class="my-0">
                {{ textSubmit }}
              </va-button>
              <va-button
                type="button"
                class="my-0"
                color="danger"
                @click="cancel">
                {{ $t("forms.cancel") }}
              </va-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'notificacoesLink-send',
  props: {
    sendData: {
      required: true,
    },
  },
  data () {
    return {
      notificacaoLink: {
        id: '',
        title: '',
        subtitle: '',
        url: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.send'),
    }
  },
  mounted () {
    this.notificacaoLink.id = ''
    this.notificacaoLink.title = ''
    this.notificacaoLink.subtitle = ''
    this.notificacaoLink.url = ''
    if (this.sendData !== null) {
      this.notificacaoLink_get(this.sendData)
    }
  },
  methods: {
    cancel () {
      this.$emit('close', false)
    },
    notificacaoLink_get (data) {
      Object.keys(data).forEach((value, _) => {
        this.notificacaoLink[value] = data[value]
      })
    },
    send () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.sending')
      const self = this
      this.$apollo
        .mutate({
          mutation: gql`
                mutation MyMutation($title: String!, $url: String!, $subtitle: String!) {
                  insert_notify_link_log_one(object: {title: $title, subtitle: $subtitle, url: $url}) {
                    id
                  }
                }
                `,
          variables: {
            title: this.notificacaoLink.title,
            subtitle: this.notificacaoLink.subtitle,
            url: this.notificacaoLink.url,
          }
          ,
        })
        .then(data => {
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
          self.$axios.post(
            '/api/messaging/link',
            {
              title: self.notificacaoLink.title,
              body: self.notificacaoLink.subtitle,
              url: self.notificacaoLink.url,
            },
          ).then(response => {
            self.buttonSubmitDisabled = false
            self.textSubmit = self.$t('forms.send')
            self.notificacaoLink = {}
            self.$emit('showMore', self.page)
            self.$emit('close', false)
            self.showToast(
              self.$t('toasts.successSend'),
              {
                icon: 'fa-check',
                position: 'top-right',
                duration: 1000,
                fullWidth: false,
              },
            )
          })
            .catch(e => {
              self.buttonSubmitDisabled = false
              self.textSubmit = self.$t('forms.send')
              self.notificacaoLink = {}
              self.showToast(
                self.$t('toasts.errorSend'),
                {
                  icon: 'fa-check',
                  position: 'top-right',
                  duration: 1000,
                  fullWidth: false,
                },
              )
            })
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.notificacaoLink = {}
          self.$emit('close', false)
          self.showToast(
            self.$t('toasts.errorCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>
